import { graphql } from '@/gql';
import { queryExecute } from '@/Utils/graphqlAPI';

export const shouldSendHomeServicesMemberAgreementEmail = async (callerId: string) => {
  const response = await queryExecute({
    fetchPolicy: 'no-cache',
    variables: {
      callerId,
    },
    query: graphql(`
      query ShouldSendHomeServicesMemberAgreementEmail($callerId: String!) {
        shouldSendHomeServicesMemberAgreementEmail(callerId: $callerId)
      }
    `),
  });

  return response.data.shouldSendHomeServicesMemberAgreementEmail;
};
